<template>
    <div class="main-container">
      <div class="combined-container">
        <div class="side-bar">
          <el-menu default-active="1">
            <el-menu-item index="1" @click="changeRoute('appearance')">
              <el-icon><brush /></el-icon>
              <span>Appearance</span>
            </el-menu-item>
          </el-menu>
        </div>
        <router-view class="vertical-container"></router-view>
      </div>
    </div>
  </template>

<script>
import { useRouter } from 'vue-router'
import { xray } from '../../config/pluginInit'
const body = document.getElementsByTagName('body')

export default {
  name: 'MainSettings',
  setup () {
    const router = useRouter()

    const changeRoute = (path) => {
      router.push({ name: path })
    }

    return {
      changeRoute
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

  <style scoped>
  .main-container {
    display: flex;
    justify-content: center;
    margin: 20px 15px;
    margin-top: 0;
  }

  .combined-container {
    display: flex;
    width: 100%;
    background: var(--container-color);
    border-radius: 20px;
    padding: 15px;
  }

  .side-bar {
    margin-right: 30px;
  }

  .vertical-container {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  </style>

<style>
.el-menu {
    border: none !important;
}
</style>